import { React, useState, useEffect, lazy } from 'react'
import queryString from 'query-string'
import { useDispatch, useSelector } from 'react-redux';
import { ssoAuthetication } from '../../../appStore/thunks/ssoAuthetication';
import { setAgentAuthetication, setAgentToken,setOrgId } from "../../../appStore/actionCreators/agent";
// import  SearchFormContainerNew  from "./SearchFormContainerNew"
import {setSearchStatus, setLandCruiseBookingNumber } from "../../../appStore/actionCreators/flightBooking"
import { useHistory, useLocation } from "react-router-dom";
import { setCruiseConfirmation, setFlightType, setLandConfirmation, setShowAgencyInfo ,setUrlUsd, setAirContract, setFirstLandCruiseSearchAttempt } from '../../../appStore/actionCreators/searchForm';
import {resetAppStore} from '../../../appStore/resetAppStore';
import { env } from '../../../appConfig';
import { getChromeSyncParams } from '../../../hooks/useSharedChrome';
import { syncSharedChrome } from '../../../services/sharedChrome';
import { CircularProgress, Box, Typography } from '@material-ui/core';
const SearchFormContainerNew = lazy(() => import('./SearchFormContainerNew'))
function SsoAuthContainer(props) {

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();

    const status = useSelector((state) => state.agentProfile.isAgentAutheticated);
    const [isRsult, setResult] = useState(undefined)
    const [newToken,setTokenSatus] =useState("")
    const [isLoadingToken, setIsLoadingToken] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")

    const token = useSelector((state) => state.agentProfile.agentToken);
	const language = useSelector( (state) => state.lang.lang)
    const agentToken = useSelector((state) => state.agentProfile.agentToken);
    const orgId = useSelector((state) => state.agentProfile.orgId);
    const isInternalUserAutheticated = useSelector((state) => state.internalUser.isInternalUserAutheticated);
    // const internalUserAccessToken = useSelector((state)=> state.internalUser.internalUserAccessToken);

    const value = queryString.parse(props.location && props.location.search);
    const tokenParam = value.token;
    const orgIdParam = value.orgId;
    const user = value.user;
    const flightType = value.flightType;
    const lang = value.lang?.toLowerCase();
    const landConfirmation = value?.landConfirmation || false;
    const cruiseConfirmation = value?.cruiseConfirmation || false;

    console.log("flightType",flightType)

    useEffect(() => { 

        if (tokenParam && Object.keys(value).length>0) {
            dispatch({ type: "RESET_EVERYTHING" });
            dispatch(setAgentToken(""))
            dispatch(setAgentAuthetication(undefined));
            dispatch(setAgentToken(tokenParam))
            dispatch(setOrgId(orgIdParam));
            setTokenSatus(tokenParam)
        } else if (status !== undefined && status === false) {
            if(agentToken.length===0 && value && Object.keys(value).length===0){
            window.location.href = env.TRAVELBRANDS_AGENT_URL
            }
        }
        
        dispatch(setSearchStatus("searchWidget"))
        if(flightType !== undefined){
            window.selectedDollarValue = flightType.toLowerCase() === "usd" ? "$" : "$"
            dispatch(setFlightType(flightType));
            dispatch(setUrlUsd(`/?user=internal&flightType=${flightType}`));  
        }
        else{
            window.selectedDollarValue = "$"
        }
    }, []) 

    useEffect(() => {
        async function verifyToken() {
            if(orgId && newToken.length>0){
                // Show loader during token verification
                setIsLoadingToken(true);
                setErrorMessage("");
                
                let seoResult = await dispatch(ssoAuthetication(orgId, newToken, lang))

                if (
                    seoResult &&
                    seoResult.hasOwnProperty("travelBusinessesId")
                ) {
                    setResult(true)
                    setErrorMessage("")
                    setIsLoadingToken(false);
                    syncSharedChrome(
                        getChromeSyncParams({
                            pathname: location.pathname,
                            search: location.search,
                            language,
                            isInternal: false,
                            token: newToken,
                            status: true,
                            forceRefresh: false,
                        })
                    );
                    if (landConfirmation) {
                        dispatch(setLandConfirmation(true));
                        dispatch(setLandCruiseBookingNumber(landConfirmation));
                        dispatch(setAirContract(['Air','Land','Cruise']))
                        dispatch(setFirstLandCruiseSearchAttempt(true));
                    }
                    if (cruiseConfirmation) {
                        dispatch(setCruiseConfirmation(true));
                        dispatch(setLandCruiseBookingNumber(cruiseConfirmation));
                        dispatch(setAirContract(['Air','Land','Cruise']))
                        dispatch(setFirstLandCruiseSearchAttempt(true));
                    }
                    history.push('/') 
                } else {
                    setResult(false)
                    setIsLoadingToken(false);
                    
                    // Show error before redirect
                    let errorMsg = "";
                    if (seoResult === "error" || seoResult === null) {
                        errorMsg = seoResult === "error" 
                            ? "Token redemption request timed out. Please try again."
                            : "Token redemption failed. Please check your token and try again.";
                    } else if (seoResult && seoResult.error) {
                        errorMsg = seoResult.message || "Token redemption failed. Please try again.";
                    } else {
                        errorMsg = "Token redemption failed. Invalid token or authentication error.";
                    }
                    
                    setErrorMessage(errorMsg);
                    // Error is shown, redirect will happen after user sees error
                }
            }
        }
        verifyToken();
    }, [newToken, orgId]);

    const getRedirectExternalUserLogin = () => {
        if (window.location.pathname !== '/SearchResults' && window.location.pathname !== "/SearchResultsFlexiDate") {
            if(newToken?.includes("XSPlus")){
                window.location.href = env.TBIDEVELOPMENT_URL
            }else{
                window.location.href = env.TRAVELBRANDS_AGENT_URL
            }       
        }
    }

    const getRedirect = () => {
        history.push("/login") 
        resetAppStore();
        dispatch(setShowAgencyInfo(true));       
    }

    useEffect(() => {        
       if(isInternalUserAutheticated === true) {          
            dispatch(setShowAgencyInfo(true)); 
        } 
    }, [])

    
const logoutClicked = document.querySelector(".bs-primary-color")
console.log('logoutClickedlogoutClicked',logoutClicked)
    // window.onunload = () => {
    //     // Clear the local storage
    //     window.MyStorage.clear()
    //  }


    return (
        <>
            {/* Display loader during token verification */}
            {isLoadingToken && (
                <Box className="token-verification-loader">
                    <CircularProgress size={50} />
                    <Typography className="token-verification-loader-text">
                        Validating token...
                    </Typography>
                </Box>
            )}

            {/* Display error message before redirect */}
            {errorMessage && !isLoadingToken && (
                <div className="token-redemption-error-page">
                    <div className="token-redemption-error">
                        <h3 className="token-redemption-error-title">Token Redemption Error</h3>
                        <p className="token-redemption-error-message">{errorMessage}</p>
                        <button 
                            className="token-redemption-error-button"
                            onClick={() => {
                                setErrorMessage("");
                                if(newToken?.includes("XSPlus")){
                                    window.location.href = env.TBIDEVELOPMENT_URL
                                }else{
                                    window.location.href = env.TRAVELBRANDS_AGENT_URL
                                }
                            }}
                        >
                            Return to Login
                        </button>
                    </div>
                </div>
            )}

            {!isLoadingToken && !errorMessage && (
                <>
                    {
                        user === undefined && !status && tokenParam === undefined && orgIdParam === undefined ?
                            getRedirect() :
                            user === 'internal' && tokenParam === undefined && orgIdParam === undefined && !isInternalUserAutheticated
                            ?
                                getRedirect() :
                                user === 'internal' && tokenParam === undefined && orgIdParam === undefined && isInternalUserAutheticated
                                ?
                                <SearchFormContainerNew showAgent="true"/>  
                                : 
                       
                        status === undefined 
                        ? null 
                        :
                            status === true ?
                                <SearchFormContainerNew /> 
                                :
                                (status === false && isRsult === false) ? 
                                    getRedirectExternalUserLogin() 
                                    : null

                  
                    }
                </>
            )}
        </>
    );
}

export default SsoAuthContainer;
